import {
  loadObjectFromServer,
  getData,
  postData,
  deleteData,
  putData
} from "@/utils";

export async function getLocations() {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await getData(APP_ROUTES.LOCATIONS);
    const replaceName = response.map(loc => {return {...loc, name:loc.name.replace(loc.street,'')}});
    return replaceName;

  } catch (e) {
    return null;
  }
}

export async function getLocationsROI(params) {
  try {
    let from_date = `from_date=${params.from_date}&to_date=${params.to_date}`;
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await getData(APP_ROUTES.LOCATIONS + "roi?" + from_date);
    return response;
  } catch (e) {
    return null;
  }
}

export async function addLocation(payload) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await postData(APP_ROUTES.LOCATIONS, payload);
  return response;
}

export async function deleteLocation(id) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const apiUrl = APP_ROUTES.LOCATIONS;
  const response = await deleteData(`${apiUrl}${id}`);
  return response;
}

export async function updateLocation(id, payload) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const apiUrl = APP_ROUTES.LOCATIONS;
  const response = await putData(`${apiUrl}${id}`, payload);
  return response;
}
//Function created to clear error during compilation to be populated later
export async function patchCompany() {
  const response = "";
  return response;
}

export async function getLocationGroup(params = '') {
  try {
    let apiUrl = `/customers/groups/`
    if (params != ''){
      apiUrl = `/customers/groups/?from_date=${params.from_date}&to_date=${params.to_date}`
    }
    const response = await getData(apiUrl);

    return response;
  } catch (e) {
    return null;
  }
}

export async function createLocationGroup(payload) {
  try {
    const apiUrl = `/customers/groups/`;
    const response = await postData(apiUrl, payload)

    return response;
  } catch (e) {
    return null;
  }
}

export async function getLocationsItemByGroupId(groupId) {
  try {
    const apiUrl = `/customers/groups/${groupId}/locations`
    const response = await getData(apiUrl);

    return response;
  } catch (e) {
    return null;
  }
}

export async function deleteLocationsGroupId(groupId) {
  try {
    const apiUrl = `/customers/groups/${groupId}`;
    const response = await deleteData(apiUrl);
  
  try {
    await this.$store.dispatch('getLocationsGroups')
  } catch (error) {
    getLocationGroup()
  }
    return response;
  } catch (e) {
    return null;
  }
}

export async function UpdateLocationsGroupId(groupId, payload) {
  try {
    const apiUrl = `/customers/groups/${groupId}`;
    const response = await putData(apiUrl, payload);

    return response;
  } catch (e) {
    return null;
  }
}

export async function getGroupWithLocationId() {
  try {
    let apiUrl = `/customers/groups-with-locations/`
    const response = await getData(apiUrl);

    return response;
  } catch (e) {
    return null;
  }
}

